import { createStyles } from '@material-ui/core'

const MaintenancePageStyles = () => createStyles({
  maintenanceContainer: {
    position: `relative`,
    top: `15vh`,
    textAlign: `center`,
  },
  image: {
    position: `relative`,
    left: 10,
    width: 128,
    marginBottom: 32,
  },
  mainText: {
    maxWidth: 550,
    margin: `0 auto`,
    padding: `0 20px 0 20px`,
  },
})

export default MaintenancePageStyles
